import React from "react";
import { useQueryContext } from "../context";
import QueryDetails from "./details";
import QueryTable from "./table";

export default () => {
  const { precatorioId } = useQueryContext();

  return precatorioId ? <QueryDetails /> : <QueryTable />;
};
